import React from 'react';

export const DoubleTrack = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__b)"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path
          d="M56.4 37.6s0 0 0 0c.5-.5.9-1.3 1.1-2.4l-7.6 2.5c2 .6 3.5.8 4.6.7 0 0 0 0 0 0 .8.3 3.4 3 .9 4.4-4.6 1.2-3-4.2-3-4.2l-1.4-.2c-.1 3.5.7 7.4 4.6 6.6 3.3-1.1 2.5-5.1.8-7.4z"
          fill="#233762"
        />
        <path fill="#fff" d="M-35.7 54.6l111.4-33-8.4-5.6-105.6 28.9z" />
        <path fill="#8291ae" d="M-37.2 65.4l111-36 1.9-7.8-111.4 33z" />
        <path
          d="M31 46.5s-.1 0 0 0c.5-.5.9-1.3 1.1-2.4l-7.6 2.5c2 .6 3.5.8 4.6.7 0 0 0 0 0 0 .8.3 3.4 3 .9 4.4-4.6 1.2-3-4.2-3-4.2l-1.5-.2c-.1 3.5.7 7.4 4.6 6.6 3.4-1.2 2.6-5.1.9-7.4z"
          fill="#233762"
        />
      </g>
      <g
        clipPath="url(#prefix__b)"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path
          d="M59.4 59.9s0 0 0 0c.5-.5.9-1.3 1.1-2.4L52.9 60c2 .6 3.5.8 4.6.7 0 0 0 0 0 0 .8.3 3.4 3 .9 4.4-4.6 1.2-3-4.2-3-4.2l-1.4-.2c-.1 3.5.7 7.4 4.6 6.6 3.3-1.1 2.5-5.1.8-7.4z"
          fill="#233762"
        />
        <path fill="#fff" d="M-32.7 77L78.8 43.9l-8.5-5.6-105.6 28.9z" />
        <path fill="#8291ae" d="M-34.2 87.7l111.1-36 1.9-7.8L-32.7 77z" />
        <path
          d="M34 68.8s0 0 0 0c.5-.5.9-1.3 1.1-2.4l-7.6 2.5c2 .6 3.5.8 4.6.7 0 0 0 0 0 0 .8.3 3.4 3 .9 4.4-4.6 1.2-3-4.2-3-4.2l-1.5-.2c-.1 3.5.7 7.4 4.6 6.6 3.4-1.1 2.6-5.1.9-7.4z"
          fill="#233762"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
